import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable, of } from 'rxjs';
import { UserService } from '../services/user.service';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        public authService: AuthService,
        public userService: UserService,
        public router: Router
    ){}

    private clearAndRedirect(): boolean {
        localStorage.removeItem('user');
        this.router.navigate(['login']);
        return false;
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {        
        const rawUser = localStorage.getItem('user');
        let user: any = null;
        try {
            user = rawUser ? JSON.parse(rawUser) : null;
        } catch {
            user = null;
        }
        const token = user?.user?.token;
        const uuid = user?.user?.token;
        const hasToken = !!token;
        const hasUuid = !!uuid;

        if(this.authService.isLoggedIn() !== true || !hasToken || !hasUuid) {
            return this.clearAndRedirect();
        }

        return this.userService.getUserDetails(uuid).pipe(
            take(1),
            map((response: any) => {
                const backendToken = response?.user?.token;
                if (!backendToken || backendToken !== token) {
                    return this.clearAndRedirect();
                }

                localStorage.setItem('user', JSON.stringify(response));
                return true;
            }),
            catchError(() => of(this.clearAndRedirect()))
        );
    }
}
